
import { myInjectionKey } from '@/mixin/ds/keys'
import { commonfunc } from '@/mixin/common'
import { pushBannerGtmData } from '~/utils/gtm'

import DaisoImage from '~/components/common/DaisoImage.vue'

export default {
  name: 'LINK',
  components: {
    DaisoImage
  },
  mixins: [commonfunc],
  inject: {
    injected: { from: myInjectionKey }
  },
  data () {
    return {
      naviShow: true,
      cateSwiperOpt: {
        slidesPerView: 'auto',
        slidesPerGroup: 10,
        spaceBetween: 20,
        loop: false,
        lazy: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        allowTouchMove: true
      },
      gridSwiperOpt: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        allowTouchMove: true
      },
      linkArr: []
    }
  },
  computed: {
    exhMtrlRgMthdCd () {
      return this.injected?.contentArr?.exhMtrlRgMthdCd || ''
      // return '30'
    },
    hrznExhbCnt () { // 가로진열수 (최대 가로 개수)
      let hrznExhbCnt = 10
      if (this.injected?.contentArr?.hrznExhbCnt) {
        hrznExhbCnt = this.injected?.contentArr?.hrznExhbCnt
      }
      return hrznExhbCnt
    },
    isMultiRow () {
      // hrznExhbCnt를 초과하면 2줄 모드
      return this.exhMtrlRgMthdCd === '30' && this.linkArr.length > this.hrznExhbCnt
    },
    needsSwiper () {
      // hrznExhbCnt * 2를 초과하면 스와이프 필요
      return this.linkArr.length > this.hrznExhbCnt * 2
    },
    paginatedLinks () {
      if (!this.isMultiRow) {
        return []
      }
      const itemsPerPage = this.hrznExhbCnt * 2 // 한 페이지에 2줄 (최대 20개)
      const pages = []
      for (let i = 0; i < this.linkArr.length; i += itemsPerPage) {
        const page = this.linkArr.slice(i, i + itemsPerPage)
        // 전체 데이터가 20개 이하이면 그대로 노출, 20개 초과일 때만 꽉 안 찬 마지막 페이지 제외
        if (this.linkArr.length <= itemsPerPage || page.length === itemsPerPage) {
          pages.push(page)
        }
      }
      return pages
    }
  },
  async mounted () {
    if (this.exhMtrlRgMthdCd === '30') {
      await this.getLinksBySolution()
    } else {
      this.setLinkArr()
    }
  },
  methods: {
    async getLinksBySolution () {
      const soltnInrkApiNm = this.injected?.contentArr?.soltnInrkApiNm
      // const soltnInrkApiNm = '/ds/brand/low-sales'
      // const soltnInrkApiNm = '/ds/brand'

      if (!soltnInrkApiNm) {
        this.$emit('noContent')
        return
      }

      await this.$AxiosBuilder
        .data()
        .build()
        .post(soltnInrkApiNm)
        .then((res) => {
          const dataArray = res.data.data || res.data || []

          this.linkArr = dataArray.map(item => ({
            linkNm: item.brndNm,
            linkNmHtml: this.convertToNewLine(this._.unescape(item.brndNm)),
            pcomLinkUrl: '/ds/dsBrand/C212/' + item.brndCd,
            pcomIconAtchFileUrl: item.pcomAtchUrl,
            pcomIconOrglFileNm: item.atchFileId,
            isNew: this.isNewBrand(item.postStDt) // 게시시작일자 30일 이내 여부
          }))

          // 데이터가 없으면 구좌 비노출
          if (this.linkArr.length === 0) {
            this.$emit('noContent')
            return
          }

          this.$nextTick(() => {
            if (this.linkArr.length > this.hrznExhbCnt * 2) {
              // hrznExhbCnt * 2 초과: 스와이프 필요
              this.naviShow = true
            } else if (this.linkArr.length > this.hrznExhbCnt) {
              // hrznExhbCnt 초과 ~ hrznExhbCnt * 2 이하: 2줄로 표시, 스와이프 불필요
              this.naviShow = false
            } else {
              // hrznExhbCnt 이하: 1줄로 표시, 네비게이션 숨김
              this.naviShow = false
              if (this.$refs.cateSwiper?.swiper) {
                this.$refs.cateSwiper.swiper.destroy()
              }
            }
          })
        }).catch((err) => {
          console.log(err)
          this.$emit('noContent')
        })
    },
    setLinkArr () {
      this.injected.contentArr.details.forEach((item) => {
        this.$set(item, 'linkNmHtml', this.convertToNewLine(this._.unescape(item.linkNm)))
        // 수기등록 링크: BO에서 설정한 PC NEW 표시여부('Y')일 때만 N 뱃지 노출
        item.isNew = item.pcomNewIdctYn === 'Y'
      })

      this.linkArr = this.injected.contentArr.details

      if (this.linkArr.length <= 10) {
        this.naviShow = false
        if (this.$refs.cateSwiper?.swiper) { this.$refs.cateSwiper.swiper.destroy() }
      }
    },
    getRowCount (itemCount) {
      // 아이템 개수에 따라 필요한 행 개수 계산
      return Math.ceil(itemCount / this.hrznExhbCnt)
    },
    isNewBrand (postStDt) {
      if (!postStDt) { return false }
      try {
        const str = String(postStDt)
        const entDate = new Date(
          parseInt(str.substring(0, 4)),
          parseInt(str.substring(4, 6)) - 1,
          parseInt(str.substring(6, 8))
        )
        const now = new Date()
        const diffDays = Math.floor((now - entDate) / (1000 * 60 * 60 * 24))
        console.log('20260316 : ', postStDt, diffDays)
        return diffDays >= 0 && diffDays <= 30
      } catch (e) {
        return false
      }
    },
    clickLink (item, index) {
      if (item) {
        if (this.$route.path === '/ds') { // Main 퀵메뉴 gtm 수집 방식 변경
          const gtmItem = {
            fileNm: '',
            bannerText: item?.linkNm,
            index: index + 1,
            location: 'PC홈메인_퀵메뉴'
          }

          pushBannerGtmData(gtmItem, true)
        }

        this.$router.push(this.unescape(item?.pcomLinkUrl || ''))
      }
    },
    convertToNewLine (text) {
      if (!text) { return '' }

      let s = String(text)

      // 1) 중점 엔티티 → <br>
      const dotMarks = ['&middot;', '&#183;']
      for (const m of dotMarks) {
        if (s.includes(m)) { s = s.split(m).join('<br>') }
      }

      // 2) 개행 후보들 → <br>
      const breaks = [
        '\r\n', '\n', '\r', // 실제 개행 문자
        '\\n', // 문자 그대로의 \n
        '&#10;', '&#13;', // 개행 엔티티(10, 13)
        '&#x0A;', '&#x0D;' // hex 표기
      ]
      for (const b of breaks) {
        if (s.includes(b)) { s = s.split(b).join('<br>') }
      }

      // 3) 유니코드 줄바꿈(LS/PS)은 includes가 잘 안 보일 수 있으니 마지막에 한 번 더 방지
      s = s.replace(/\u2028|\u2029/g, '<br>') // ← 이 한 줄만 정규식(불편하면 제거 가능)

      return s
    }
  }
}
